import { ScrollView, StyleSheet, View } from "react-native";
import { useTranslation } from "react-i18next";
import { useState } from "react";

import { WorkspaceHeader } from "../components/chatNewInterface/interfaceComponents/workspaceHeader/WorkspaceHeader";
import { UserData } from "../containers/settings/CompanionSettings/UserData";
import { ChatIntegration } from "../containers/settings/CompanionSettings/ChatIntegration";
import { HelpContainer } from "../containers/settings/CompanionSettings/HelpContainer/HelpContainer";
import CompanionLayout from "../layouts/CompanionLayout";
import { semanticColors } from "../styles/design-system";
import TabNavigator from "../components/common/general/TabNavigator/TabNavigator";
import { useAppConfig } from "../AppConfigProvider";

const ChatSettings = () => {
  const { t } = useTranslation();
  const { primaryColor } = useAppConfig();
  const [activeTab, setActiveTab] = useState("account");

  const tabData = [
    { key: "account", title: "Account" },
    { key: "help", title: "Help" },
    { key: "integrations", title: "Integrations" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "account":
        return <UserData />;
      case "help":
        return <HelpContainer />;
      case "integrations":
        return <ChatIntegration />;
      default:
        return null;
    }
  };

  return (
    <CompanionLayout>
      <View style={styles.container}>
        <WorkspaceHeader title={t("Settings")} />
        <View style={styles.tabNavigatorWrapper}>
          <TabNavigator
            tabData={tabData}
            activeTab={activeTab}
            onTabPress={setActiveTab}
            activeTabColor={primaryColor}
            useTranslationText={false}
            containerStyle={styles.tabNavigator}
          />
        </View>
        <ScrollView style={styles.scrollView} tabIndex={0}>
          <View style={styles.settingsSections}>{renderTabContent()}</View>
        </ScrollView>
      </View>
    </CompanionLayout>
  );
};

const styles = StyleSheet.create({
  container: {
    height: "100%",
    display: "flex",
    // @ts-expect-error - works on web
    maxHeight: "100vh",
    overflow: "hidden",
    backgroundColor: semanticColors.surface.light,
  },
  tabNavigatorWrapper: {
    backgroundColor: semanticColors.surface.light,
    paddingHorizontal: 24,
  },
  tabNavigator: {
    width: "100%",
    maxWidth: 624,
    marginHorizontal: "auto",
  },
  scrollView: {
    flex: 1,
  },
  settingsSections: {
    width: "100%",
    maxWidth: 624,
    marginHorizontal: "auto",
    display: "flex",
    gap: 32,
    paddingVertical: 24,
  },
});

export default ChatSettings;
